<template>
  <div class="article-code">
    <div class="article-code-text">
      <div class="article-code-text-sub h6">加入「合创」社区</div>
      <div class="article-code-text-main h3">发现更多精彩内容</div>
    </div>
    <div class="article-code-img">
      <img
        :src="src"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleCode",
  props: {
    src: {
      type: String,
      default: 'https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210630165806656-web_pic_qrcode@2x.png'
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@style/base";
$lg: default;
$md: 792px;
$sm: 616px;
@include setThemeClass {
  .article-code {
    @include media(
      (
        $md: (
          display: none,
        ),
      )
    );
    margin-top: 60px;
    padding: 15px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: getThemeVal(backgroundColorGray);
    border-radius: 4px;
    @include media(
      (
        $md: (
          margin-top: 30px,
        ),
      )
    );
    .article-code-text {
      .article-code-text-sub {
        letter-spacing: 2px;
      }
      .article-code-text-main {
        letter-spacing: 2px;
        margin-top: 9px;
      }
    }
    .article-code-img {
      flex-shrink: 0;
      width: 90px;
      height: 90px;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
}
</style>
